export const Routes = [{
  path: '/guide/:code',
  title: '讲解播放',
  meta: { public: true },
  component: () => import('@/views/guide-content/PublicGuideContent'),
  children: [],
}, {
  path: '/login',
  title: '登录',
  component: () => import('@/views/login/Login'),
  children: [],
}, {
  path: '/change-password',
  title: '修改密码',
  component: () => import('@/views/user/ChangePassword'),
  children: [],
}, {
  path: '/',
  icon: "ios-home",
  title: '首页',
  component: () => import('@/layouts/OnlyHeaderLayout'),
  children: [{
    path: '/404',
    title: '页面消失',
    component: () => import('@/layouts/NotFound'),
  }],
}]
